// src/components/Blocks/PhotoGallery/Edit.jsx
import React from 'react';
import { SidebarPortal } from '@plone/volto/components';
import { withBlockExtensions } from '@plone/volto/helpers';
import PhotoGalleryView from './View';
import PhotoGalleryData from './Data';
import schema from './schema';

const PhotoGalleryEdit = (props) => {
  const { data, onChangeBlock, block, selected } = props;
  const gallerySchema = schema(props);

  // Normalizza i dati con valori di default
  const normalizedData = {
    ...data,
    title: data.title ?? '',
    titleAlignment: data.titleAlignment ?? gallerySchema.properties.titleAlignment.default,
    images: data.images ?? [],
  };

  return (
    <>
      <PhotoGalleryView {...props} data={normalizedData} />
      <SidebarPortal selected={selected}>
        <PhotoGalleryData
          data={normalizedData}
          block={block}
          onChangeBlock={onChangeBlock}
          schema={gallerySchema}
        />
      </SidebarPortal>
    </>
  );
};

export default withBlockExtensions(PhotoGalleryEdit);